import styled from "@emotion/styled";
import BackgroundPhone from '../img/backGroundPC.png'
import backgroundPC from '../img/backGroundPC.png'

export const Main = styled.div`
  padding: 20px;
  flex-direction: column;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100%; /* Use min-height to ensure it takes full height but allows growth */
  width: 100%;

  background-image: url(${BackgroundPhone}); /* Фон для мобильной версии по умолчанию */
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  // Стили для ПК-версии
  @media (min-width: 600px) {
    background-image: url(${backgroundPC}); /* Фон для ПК версии */
  }

  /* Стили для мобильных устройств */
  @media (max-width: 600px) {
    padding: 10px;
    min-height: 100%; /* Ensure full height on mobile */
    justify-content: center; /* Maintain centering */
    align-items: center; /* Maintain centering */
  }
`;